module.exports = __webpack_public_path__ + "img/img-8.355a7236.png";